import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { ThemeProvider } from '@emotion/react';
import {
  Appearance,
  black,
  gray01,
  primary,
  white,
  whiteFix,
} from 'presentations/views/styles/color';

interface Props {
  children: ReactNode;
  className?: string;
}

export default function Component(props: Props) {
  return (
    <ThemeProvider theme={{ appearance: Appearance.Dark }}>
      <Container className={props.className}>{props.children}</Container>
    </ThemeProvider>
  );
}
const Container = styled.div`
  background-color: ${white};
  color: ${black};
  button {
    background-color: ${white};
    color: ${gray01};
    &.Mui-selected {
      color: ${black};
    }
  }
  svg {
    color: ${whiteFix};
  }
`;
